import { render } from "./multiLanguage2.vue?vue&type=template&id=7c8e6ef2"
import script from "./multiLanguage2.vue?vue&type=script&lang=js"
export * from "./multiLanguage2.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__